import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.revoked_view.title',
        defaultMessage: 'Oops, it looks like something went wrong'
    },
    description: {
        id: '_.revoked_view.description',
        defaultMessage: '_'
    },
    phoneNumber: {
        id: '_.revoked_view.phoneNumber',
        defaultMessage: '_'
    }
});
